(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
class complementarySlider extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    if (typeof Swiper !== 'undefined') {
      this.swiper = new Swiper(this, {slidesPerView: 'auto', spaceBetween: 15, freeMode: true, mousewheel: {forceToAxis: true}});
    }
    this.form = this.closest('form');
    this.basePrice = Number(this.dataset.basePrice);
    this.items = [...this.querySelectorAll('[data-upsell-id]')];
    this.filters = [...this.querySelectorAll('.upsell-filters')];
    this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: this.dataset.currency || 'USD'});
    this.filters.forEach(filter => {
      filter.variants = JSON.parse(filter.querySelector('[data-upsell-variants]').textContent);
      const initial = filter.variants.find(variant => variant.available) || filter.variants[0];
      filter.querySelectorAll('[data-option-index]').forEach(group => {
        group.querySelectorAll('button').forEach(button => {
          button.classList.toggle('active', button.dataset.optionValue === initial.options[Number(group.dataset.optionIndex)]);
          button.setAttribute('aria-pressed', String(button.classList.contains('active')));
          button.addEventListener('click', () => {
            group.querySelectorAll('button').forEach(other => {
              other.classList.toggle('active', other === button);
              other.setAttribute('aria-pressed', String(other === button));
            });
            this.sync();
          });
        });
      });
    });
    this.items.forEach(item => {
      const toggle = () => {
        this.selected = this.selected === item ? null : item;
        this.sync();
      };
      item.addEventListener('click', toggle);
      item.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });
    this.onVariant = event => {
      const variant = event.detail?.variant;
      if (variant && Number.isFinite(Number(variant.price))) {
        this.basePrice = Number(variant.price);
        requestAnimationFrame(() => this.sync());
      }
    };
    this.eventRoot = this.closest('.product-main') || this.form;
    this.eventRoot.addEventListener('variant:changed', this.onVariant);
    this.sync();
  }
  disconnectedCallback() {
    this.eventRoot?.removeEventListener('variant:changed', this.onVariant);
    this.swiper?.destroy();
    this.ready = false;
  }
  sync() {
    let selectedVariant = null;
    this.filters.forEach(filter => {
      const options = [...filter.querySelectorAll('[data-option-index]')].map(group => group.querySelector('button.active')?.dataset.optionValue);
      const variant = filter.variants.find(candidate => candidate.options.every((value, index) => value === options[index]));
      const item = this.items.find(card => card.dataset.upsellId === filter.id);
      const active = item === this.selected;
      filter.classList.toggle('active', active);
      item.classList.toggle('upsell-active', active);
      item.setAttribute('aria-pressed', String(active));
      const price = item.querySelector('.upsell-main-price');
      price.textContent = variant ? this.money.format(variant.price / 100) : this.dataset.unavailable;
      const oldPrice = item.querySelector('.upsell-old-price');
      if (oldPrice) {
        oldPrice.hidden = !variant || !(variant.compare_at_price > variant.price);
        if (!oldPrice.hidden) oldPrice.textContent = this.money.format(variant.compare_at_price / 100);
      }
      if (active) selectedVariant = variant;
    });
    this.querySelector('[name="upsell-id"]').value = selectedVariant?.available ? selectedVariant.id : '';
    const total = this.basePrice + (selectedVariant?.available ? selectedVariant.price : 0);
    const priceList = this.form.querySelector('.ProductMeta__PriceList');
    const price = priceList?.querySelector('.price-main');
    if (price) price.textContent = this.money.format(total / 100);
    const compare = priceList?.querySelector('.Price--compareAt');
    if (compare) compare.hidden = Boolean(this.selected);
    const submit = this.form.querySelector('.ProductForm__AddToCart');
    if (submit) {
      if (this.selected && !selectedVariant?.available) {
        if (!submit.disabled) { submit.disabled = true; this.disabledSubmit = true; }
      } else if (this.disabledSubmit) {
        submit.disabled = false;
        this.disabledSubmit = false;
      }
    }
  }
}
if (!customElements.get('complementary-slider')) customElements.define('complementary-slider', complementarySlider);


  } catch(e) { console.error(e); }
})();
})();
